var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"toggle-switch",class:[ _vm.block ? `block` : `inline` ]},[_c('span',{staticClass:"toggle-switch-label",class:{
    active: _vm.value === false,
  }},[_vm._v("\n    "+_vm._s(_vm.leftLabel)+"\n  ")]),_vm._v(" "),_c('toggle-button',{staticClass:"toggle-switch-toggle",class:{ active : _vm.value === true },attrs:{"value":_vm.value,"sync":true},on:{"change":function($event){return _vm.$emit(`change`, $event.value)}}}),_vm._v(" "),_c('span',{staticClass:"toggle-switch-label",class:{
    active: _vm.value === true,
  }},[_vm._v("\n    "+_vm._s(_vm.rightLabel)+"\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }